let loadJs = src => {
    return new Promise((resolve, reject) => {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;
        script.onload = resolve
        script.onerror = reject
        document.body.appendChild(script);
    })
}
export default {
    loadJs
}
